// highlight.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight',
    standalone: true
})
export class HighlightPipe implements PipeTransform {
  transform(text: string, search: string): string {
    const encoded = this.htmlEncode(text);
    if (!search || search.trim() === '') {
      return encoded;
    }

    const regex = new RegExp(`(${this.escapeRegExp(search)})`, 'gi');
    return encoded.replace(regex, '<mark class="highlight">$1</mark>');
  }

  private htmlEncode(value: string): string {
    if (!value) return value;
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private escapeRegExp(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}